import { useCallback, useRef } from 'react';
import useModal from '../../../hooks/useModal';

export default () => {
  const { closeModal } = useModal();
  const closers = useRef({});

  return useCallback(
    (modalId) => {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (!closers.current[modalId]) {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        closers.current[modalId] = () => closeModal(modalId);
      }

      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      return closers.current[modalId];
    },
    [closers, closeModal]
  );
};
